define.alias("shared/components/shared/ember-drop-multi-select-item", "preview-grid/components/shared/ember-drop-multi-select-item");